const getDefaultLang = () => localStorage.getItem('language') || 'pt-br';

const initialState = {
  language: getDefaultLang(),
  institution: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case '@settings/SET_LANGUAGE':
      localStorage.setItem('language', action.language);

      return {
        ...state,
        language: action.language,
      };

    case '@settings/SET_INSTITUTION':
      return {
        ...state,
        institution: action.institution,
      };

    case '@settings/CLEAR_SETTINGS':
      return initialState;

    default:
      return state;
  }
};

export default reducer;
